import api from './client';

export interface AnalyticsOverview {
  callsToday: number;
  callsThisMonth: number;
  callsMonthChange: number | null;
  minutesUsed: number;
  minutesRemaining: number;
  minutesTotal: number;
  answerRate: number;
  conversionRate: number;
  activeCampaigns: number;
  totalAgents: number;
}

export interface TimelinePoint {
  date: string;
  calls: number;
  answered: number;
  converted: number;
  minutes: number;
}

export interface CampaignPerformance {
  campaignId: string;
  name: string;
  totalCalls: number;
  answerRate: number;
  conversionRate: number;
  avgDuration: number;
  cost: number;
}

export interface AgentPerformance {
  agentId: string;
  name: string;
  callsHandled: number;
  avgDuration: number;
  satisfactionScore: number | null;
}

export interface CurrentUsage {
  plan: string;
  minutesUsed: number;
  minutesTotal: number;
  minutesRemaining: number;
  percentUsed: number;
  daysLeftInPeriod: number;
  projectedOverage: number;
}

export interface UsageHistory {
  month: string;
  minutesUsed: number;
  cost: number;
  callCount: number;
}

export interface RecentCall {
  id: string;
  phone: string;
  agent: string;
  duration: number | null;
  status: string;
  outcome: string;
  timestamp: string;
}

export const analyticsApi = {
  getOverview: () => api.get<{ data: AnalyticsOverview }>('/api/v1/analytics/overview'),
  getTimeline: (period: '7d' | '30d' | '90d' = '30d') =>
    api.get<{ data: TimelinePoint[] }>(`/api/v1/analytics/calls/timeline?period=${period}`),
  getCampaignPerformance: () =>
    api.get<{ data: CampaignPerformance[] }>('/api/v1/analytics/campaigns/performance'),
  getAgentPerformance: () =>
    api.get<{ data: AgentPerformance[] }>('/api/v1/analytics/agents/performance'),
  getCurrentUsage: () =>
    api.get<{ data: CurrentUsage }>('/api/v1/analytics/usage/current'),
  getUsageHistory: (months: number = 3) =>
    api.get<{ data: UsageHistory[] }>(`/api/v1/analytics/usage/history?months=${months}`),
  getRecentCalls: () =>
    api.get<{ data: RecentCall[] }>('/api/v1/analytics/calls/recent'),
};
